module.exports = __webpack_public_path__ + "static/schwartz-hex-084d72dfc79d205928ade70a93003342.png";